import { CheckCircle } from "lucide-react";

const Faqs1 = () => {
  const faqData = [
    {
      title: "Income Documents Required",
      items: [
        "T4 - Employment Income",
        "T4A - Other Income (e.g. pension, retirement, old age security)",
        "T4E - Statement of Employment Insurance",
        "T3 - Statement of Trust Income",
        "T5 - Statement of Investment Income",
        "T776 - Rental Income",
        "T4RSP - Statement of RRSP Income",
        "Capital Gains",
        "Self-employment Income",
        "T5007 - WSIB Income or Social Assistance",
        "Other Income Slips",
      ],
    },
    {
      title: "Deduction Receipts Needed",
      items: [
        "All child care expenses",
        "Registered Retirement Savings Plan",
        "Union & professional dues",
        "T2202 - Employment Expenses",
        "Interest expense",
        "Public transit passes",
        "Home Buyer Plan - RRSP",
        "T2200 - Disability Certificate",
        "Interest paid on Student loan",
        "T2202, TL11 - Tuition fees",
        "Medical Expenses",
        "Charitable donations",
        "Property taxes/Rent paid",
      ],
    },
    {
      title: "Other Information Necessary",
      items: [
        "Copy of your last Year Notice of Assessment",
        "Personal tax installments paid",
        "A void cheque for direct deposit of income tax refund, HST & Child tax benefit credit",
      ],
    },
    {
      title: "Personal Information Required",
      items: [
        "Name, Address, Date of Birth, SIN, Your Spouse, and Your Dependents.",
      ],
    },
  ];

  return (
    <div className="max-w-3xl mx-auto p-6">
      {faqData.map((faq, index) => (
        <div key={index} className="border-b border-gray-300 pb-4 mb-4">
          <h2 className="text-4xl font-semibold text-gray-900">{faq.title}</h2>
          <ul className="mt-2 space-y-2">
            {faq.items.map((item, i) => (
              <li key={i} className="flex text-xl mt-6 items-center text-gray-700">
                <CheckCircle className="w-5 h-5 text-gray-500 mr-2" />
                {item}
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
};

export default Faqs1;
